@if (menuItems$ | async; as menuItems) {
  @if (menuItems.length > 0) {
    <ds-dropdown
      class="top-navbar-control-hub-dropdown"
      [ds-tooltip]="'control_hub_dropdown_tooltip_text' | translate"
      [tooltipPlacement]="DsTooltipPosition.bottom"
      [selectedValue]="(currentActiveMenuItem$ | async)?.id"
      data-test-id="launcher-dropdown"
    >
      <ds-dropdown-toggle
        [icon]="Icons.Grid"
        [variant]="DsButtonVariants.microAction"
        [ariaLabel]="'control_hub_dropdown_tooltip_text' | translate"
      >
      </ds-dropdown-toggle>
      <div ds-dropdown-menu>
        @for (menuItem of menuItems; track menuItem.routerLink) {
          <ds-dropdown-item
            [icon]="menuItem.iconName"
            [label]="menuItem.label | translate"
            [href]="menuItem.routerLink"
            [value]="menuItem.id"
          ></ds-dropdown-item>
        }
      </div>
    </ds-dropdown>
  }
}
